// plugins/toursReservationsPlugin.js
import device from 'current-device';

function normalizeBookingLanguage(language) {
  return String(language || '').toLowerCase().startsWith('es') ? 'es' : 'en';
}

function withBookingLanguage(dataToUpdate, language) {
  const bookingLanguage = normalizeBookingLanguage(language);
  let deviceInfo = {};

  if (typeof dataToUpdate?.device_info === 'string' && dataToUpdate.device_info.trim()) {
    try {
      deviceInfo = JSON.parse(dataToUpdate.device_info);
    } catch (error) {
      deviceInfo = {};
    }
  } else if (dataToUpdate?.device_info && typeof dataToUpdate.device_info === 'object') {
    deviceInfo = dataToUpdate.device_info;
  }

  return {
    ...dataToUpdate,
    booking_language: bookingLanguage,
    device_info: JSON.stringify({
      ...deviceInfo,
      bookingLanguage,
      booking_language: bookingLanguage,
      browserData: {
        ...(deviceInfo.browserData || {}),
        bookingLanguage,
      },
    }),
  };
}

function recalcTotals(state) {
  const subtotal = Number(state.shoppingCart.subtotal || 0);
  const enabled  = !!state.taxRules.enabled;
  const percent  = Number(state.taxRules.percent || 0);

  const taxRate   = enabled && percent > 0 ? percent : 0;
  const taxAmount = +(subtotal * (taxRate / 100)).toFixed(2);
  const total     = +(subtotal + taxAmount).toFixed(2);

  state.shoppingCart.tax        = taxRate;
  state.shoppingCart.tax_amount = taxAmount;
  state.shoppingCart.total      = total;
}

  const state = {
    tours: [],
    shoppingCart: {
      toursList: [],
      extrasList: [],
      client: {
        fname: '',
        lname: '',
        email: '',
        phone: '',
      },
      booking_id: '',
      client_id: '',
      status: 0,
      subtotal: 0,
      tax: 0,
      tax_amount: 0,
      total: 0,
      special_requests: '',
      promoCode: '',
      repCode: '',
      sendEmail: true,
    },
    taxRules: {
      enabled: false,
      percent: 0 
    },
    toursReservations: {
      tourID: null,
      ArrivalDate: '',
      selectedTime: null,

      adults: 0,
      kids: 0,
      infants: 0,
      

      deviceInfo: {
        type: '',  // mobile, desktop, tablet
        orientation: '',  // portrait, landscape
        browserData: {},
      },
      utmParams: {},
      PDFlink: '',
      ally_booking_id: '',
      // ... Cualquier otro campo necesario
      // changexx
    },
  };
  
  const mutations = {

    SET_TAX_RULES(state, { enabled, percent }) {
      state.taxRules.enabled = !!enabled;
      state.taxRules.percent = Number(percent) || 0;
    },

    RECALC_TOTALS(state) {
      recalcTotals(state);
    },
    
    SET_TOURS(state, tours) {
      state.tours = tours;
    },
    SET_TOUR_RESERVATIONS(state, payload) {
      state.toursReservations = { ...state.toursReservations, ...payload };
    },
    SET_PDF_LINK(state, link) {
      state.PDFlink = link;
    },
    CLEAR_TOUR_RESERVATIONS(state) {
      state.toursReservations.selectedTime = null;
      state.toursReservations.adults = 0;
      state.toursReservations.kids = 0;
      state.toursReservations.infants = 0;
    },

    CLEAR_SHOPPING_CART(state) {
      state.shoppingCart = {
        toursList: [],
        extrasList: [],
        client: {
          fname: '',
          lname: '',
          email: '',
          phone: '',
        },
        booking_id: '',
        client_id: '',
        status: 0,
        subtotal: 0,
        tax: 0,
        tax_amount: 0,
        total: 0,
        special_requests: '',
        promoCode: '',
        repCode: '',
        sendEmail: true,
        // ... Cualquier otro campo necesario
      };
      recalcTotals(state);
    },

    SET_DEVICE_INFO(state, payload) {
      state.toursReservations.deviceInfo = payload;
    },
    SET_UMT_PARAMS(state, utmData) {
      state.toursReservations.utmParams = utmData;
    },
    SET_ARRIVAL_DATE(state, date) {
      state.toursReservations.ArrivalDate = date; // Corrected path
    },
    SET_SELECTED_TIME(state, time) {
      state.toursReservations.selectedTime = time;
    },
    ADD_TOUR_TO_CART(state, tour) {
      const existingTour = state.shoppingCart.toursList.find(item => item.tourID === tour.tourID);
      if (existingTour) {
        // Actualizar las cantidades y el subtotal si el tour ya existe en el carrito
        existingTour.adults = tour.adults;
        existingTour.kids = tour.kids;
        existingTour.infants = tour.infants;
        existingTour.subtotal = tour.subtotal;
        existingTour.day = tour.day;
        existingTour.time = tour.time;
        existingTour.image = tour.image;
        existingTour.name = tour.name;
        existingTour.is_group_pricing = tour.is_group_pricing;
        existingTour.extra_hours = tour.extra_hours;
      } else {
        // Añadir el tour al carrito si no existe
        state.shoppingCart.toursList.push(tour);
      }
  
      // Actualizar el subtotal general del carrito
      const toursSubtotal  = state.shoppingCart.toursList.reduce((acc, i) => acc + Number(i.subtotal || 0), 0);
      const extrasSubtotal = state.shoppingCart.extrasList.reduce((acc, e) => acc + Number(e.total || 0), 0);
      state.shoppingCart.subtotal = +(toursSubtotal + extrasSubtotal).toFixed(2);

      // 👇 Recalcular montos globales
      recalcTotals(state);
    },
    REMOVE_TOUR_FROM_CART(state, index) {
      state.shoppingCart.toursList.splice(index, 1);

      const toursSubtotal  = state.shoppingCart.toursList.reduce((acc, i) => acc + Number(i.subtotal || 0), 0);
      const extrasSubtotal = state.shoppingCart.extrasList.reduce((acc, e) => acc + Number(e.total || 0), 0);
      state.shoppingCart.subtotal = +(toursSubtotal + extrasSubtotal).toFixed(2);

      recalcTotals(state);
    },
    ADD_EXTRA_TO_CART(state, extra) {
      const existing = state.shoppingCart.extrasList.find(e => e.id === extra.id);
      if (existing) {
        existing.quantity = extra.quantity;
        existing.total = Number(extra.rate || 0) * Number(extra.quantity || 0);
      } else {
        state.shoppingCart.extrasList.push(extra);
      }

      const toursSubtotal  = state.shoppingCart.toursList.reduce((acc, i) => acc + Number(i.subtotal || 0), 0);
      const extrasSubtotal = state.shoppingCart.extrasList.reduce((acc, e) => acc + Number(e.total || 0), 0);
      state.shoppingCart.subtotal = +(toursSubtotal + extrasSubtotal).toFixed(2);

      recalcTotals(state);
    },

    REMOVE_EXTRA_FROM_CART(state, extraId) {
      state.shoppingCart.extrasList = state.shoppingCart.extrasList.filter(e => e.id !== extraId);

      const toursSubtotal  = state.shoppingCart.toursList.reduce((acc, i) => acc + Number(i.subtotal || 0), 0);
      const extrasSubtotal = state.shoppingCart.extrasList.reduce((acc, e) => acc + Number(e.total || 0), 0);
      state.shoppingCart.subtotal = +(toursSubtotal + extrasSubtotal).toFixed(2);

      recalcTotals(state);
    },
    // ... otras mutaciones que puedas necesitar
  };
  
  const actions = {

    setTaxRules({ commit }, { enabled, percent }) {
      commit('SET_TAX_RULES', { enabled, percent });
      commit('RECALC_TOTALS');
    },
    saveTours({ commit }, tours) {
      commit('SET_TOURS', tours);
    },
    detectDeviceInfo({ commit, rootGetters }) {
      const bookingLanguage = normalizeBookingLanguage(rootGetters.getBookingLanguage);
      // console.log("Detecting device info...");
      device.onChangeOrientation(() => {
        // console.log("Orientation change detected.");
        commit('SET_DEVICE_INFO', {
          type: device.type,
          orientation: device.orientation,
          bookingLanguage,
          booking_language: bookingLanguage,
          browserData: {
            userAgent: navigator.userAgent,
            language: navigator.language,
            bookingLanguage,
            platform: navigator.platform,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        });
      });
  
      // Llama inicialmente sin esperar un cambio de orientación
      commit('SET_DEVICE_INFO', {
        type: device.type,
        orientation: device.orientation,
        bookingLanguage,
        booking_language: bookingLanguage,
        browserData: {
          userAgent: navigator.userAgent,
          language: navigator.language,
          bookingLanguage,
          platform: navigator.platform,
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      });
    },
    captureUTMParameters({ commit }) {
      // console.log("Capturing UTM parameters...");
      const urlParams = new URLSearchParams(window.location.search);
      const utmData = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
      };
      // console.log(utmData);
      commit('SET_UMT_PARAMS', utmData);
    },
    updateToursReservations({ commit }, payload) {
      commit('SET_TOUR_RESERVATIONS', payload);
    },
    clearToursReservations({ commit }) {
      commit('CLEAR_TOUR_RESERVATIONS');
    },
    clearShoppingCart({ commit }) {
      commit('CLEAR_SHOPPING_CART');
    },
    async create_toursReservations({ rootGetters }, { dataToUpdate }) {
      const API_URL = `${process.env.VUE_APP_BASEURL}public/tour-reservations`;
      try {
        const payload = withBookingLanguage(dataToUpdate, rootGetters.getBookingLanguage);
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
    
        const response = await res.json();
        console.log('Response from server:', response);
    
        if (!res.ok) {
          throw new Error(response.message || 'Error creating tour reservation');
        }
    
        return response;
      } catch (error) {
        console.error('Error creating tour reservation:', error);
        throw error;
      }
    },
    addExtraToCart({ commit }, extra) {
      commit('ADD_EXTRA_TO_CART', extra);
    },
    removeExtraFromCart({ commit }, extraId) {
      commit('REMOVE_EXTRA_FROM_CART', extraId);
    },

    // async create_toursReservations(_, {dataToUpdate, status}) {
    //   const API_URL = `${process.env.VUE_APP_BASEURL}public/apt-reservations`;
    //   try {
    //       const payload = {
    //           bookingObject: JSON.stringify(dataToUpdate.bookingObject)
    //       };
  
    //       const res = await fetch(API_URL, {
    //           method: 'POST',
    //           headers: {
    //               'Accept': 'application/json',
    //               'Reservation-Status': status,
    //               'Content-Type': 'application/json',
    //           },
    //           body: JSON.stringify(payload)
    //       });
  
    //       const response = await res.json();
    //       console.log('Response from server:', response);
    //       return response;
    //   } catch (error) {
    //       console.error('Error during query:', error);
    //       throw new Error(error);
    //   }
    // },
    async validateBookingTime(_, dataToUpdate) {
      const API_URL = `${process.env.VUE_APP_BASEURL}public/validateBookingTime`;
      try {
          const payload = {
              bookingObject: JSON.stringify(dataToUpdate.bookingObject)
          };

          const res = await fetch(API_URL, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload)
          });

          const response = await res.json();
          console.log('Response from server:', response);
          return response;
      } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
      }
    },
    async create_ally_toursReservations(_, {dataToUpdate, status}) {
      const API_URL = `${process.env.VUE_APP_BASEURL}public/ally-apt-reservations`;
      // console.log('sent to ally');
      try {
          const payload = {
              bookingObject: JSON.stringify(dataToUpdate.bookingObject)
          };

          const res = await fetch(API_URL, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Reservation-Status': status,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload)
          });

          const response = await res.json();
          console.log('Response from server:', response);
          return response;
      } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
      }
    },
    async initiate_StripePayment(_, {dataToUpdate, companyID}) {
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}payment/initiate`;
        // console.log('JSON.stringify(dataToUpdate)', JSON.stringify(dataToUpdate));
        // console.log('dataToUpdate: ', dataToUpdate);
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'User-Company': companyID,
            // 'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json', // Indica que los datos son JSON
          },
          body: JSON.stringify(dataToUpdate) // Convierte los datos a una cadena JSON
        });
    
        const response = await res.json();
        console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async create_Client(_, dataToUpdate) {
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}public/clients`;
        // console.log('API_URL', API_URL);
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json', // Indica que los datos son JSON
          },
          body: JSON.stringify(dataToUpdate) // Convierte los datos a una cadena JSON
        });
    
        const response = await res.json();
        console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async getCommercialAlliesInfo(_, ally_company_id) {
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}find-commercial-allies/${ally_company_id}`;
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async findCommercialAlliesInfo(_, allyID) {
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}public/find-commercial-ally/${allyID}`;
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async getRepresentativeInfo(_, {userCompany, repID}) {
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}public/find-sales-representative/${repID}`;
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'User-Company': userCompany
          },
        });
    
        const response = await res.json();
    
        console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async get_all_TranspDest() {
      try {

        const API_URL = `${process.env.VUE_APP_BASEURL}public/transportation_destinations`;
        // console.log('userType: ', userType)

        // Create headers object with common headers
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: headers
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
  
        return response;
      } catch (error) {
        // console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async getTranspDestInfo(_,destinationID) {
      try {
        // console.log('destinationID', destinationID);
        const API_URL = `${process.env.VUE_APP_BASEURL}public/transportation_destinations/${destinationID}`;
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async get_all_tours(_, userCompany) {
      try {

        // console.log('sessionUser', sessionUser);
        const API_URL = `${process.env.VUE_APP_BASEURL}public/get-all-tours`;
        // console.log('userType: ', userType)

        // Create headers object with common headers
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'User-Company': userCompany
        };
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: headers
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
  
        return response;
      } catch (error) {
        // console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async get_tour_info(_,tourID) {
      try {
        // console.log('destinationID', destinationID);
        const API_URL = `${process.env.VUE_APP_BASEURL}public/get-tour-info/${tourID}`;
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    async get_tour_info_for_booking(_,{tourID, companyID, selected_date}) {
      try {
        // console.log('destinationID', destinationID);
        const API_URL = `${process.env.VUE_APP_BASEURL}public/get-tour-info-booking/${tourID}?selected_date=${selected_date}&company_id=${companyID}`;

        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
    
        const response = await res.json();
    
        // console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    updateArrivalDate({ commit }, date) {
      commit('SET_ARRIVAL_DATE', date);
      // Si necesitas sincronizar con el backend, puedes hacer una llamada aquí
      // Por ejemplo:
      // return axios.post('/api/update-arrival-date', { date });
    },
    updateSelectedTime({ commit }, time) {
      commit('SET_SELECTED_TIME', time);
    },
    addTourToCart({ commit }, tour) {
      commit('ADD_TOUR_TO_CART', tour);
    },
    removeTourFromCart({ commit }, index) {
      commit('REMOVE_TOUR_FROM_CART', index);
    },
    async get_all_TourAddons(_, userCompany) {
      try {

        const API_URL = `${process.env.VUE_APP_BASEURL}public/tour-addons`;

        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'User-Company': userCompany
        };

        const res = await fetch(API_URL, {
          method: 'GET',
          headers
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        throw new Error(error);
      }
    },
    async getTourReservationsInfo(_,ResID) {
      console.log('aptResID: ', ResID);
      try {
        const API_URL = `${process.env.VUE_APP_BASEURL}public/tour-reservations-info/${ResID}`;
        console.log('API_URL on INFO: ', API_URL);
    
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${Authtoken}`
          },
        });
    
        const response = await res.json();
    
        console.log('Response from server:', response);
    
        if ('errors' in response) {
          return response.errors;
        }
    
        return response;
      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
    
    // ... todas tus acciones aquí, asegurándote de que cada una esté correctamente cerrada
  };
  
  const getters = {

    getTours(state) {
      return state.tours;
    },
    getToursReservations(state) {
      return state.toursReservations;
    },
    getShoppingCart(state) {
      return state.shoppingCart;
    },
    getDeviceInfo(state) {
      return state.toursReservations.deviceInfo;
    },
    getUTMParams(state) {
      return state.toursReservations.utmParams;
    },
    getToursList(state) {
      return state.shoppingCart.toursList;
    },
    getCartSubtotal(state) {
      return state.shoppingCart.subtotal;
    },
    getCartTaxPercent: (s) => s.shoppingCart.tax,
    getCartTaxAmount:  (s) => s.shoppingCart.tax_amount,
    getCartTotal:      (s) => s.shoppingCart.total,
    // ... otros getters que puedas necesitar
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
